<template>
  <batch-title ref="batch_title_ref" :page-config="pageConfig" />
</template>

<script>

export default {
  components: {
    'batch-title': () => import('@/views/auxiliary/title/components/batch/index.vue'),
  },
  props: {
    pageConfig: {
      type: Object,
      default() {
        return null;
      },
    },
  },

  methods: {
    /**
     * 获取已选项
     */
    async getAssignSelection() {
      try {
        const res = await this.$refs['batch_title_ref'].onBatchAdd();
        return Promise.resolve(res);
      } catch {
        return [];
      }
    },
  },
};
</script>
